export const STATE_NAME = 'searchAlertUnsubscribe';
